var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Gender } from '@debbie/common/dist';
import * as customersAPI from '@debbie/cortex/dist/api/customers';
import { selectExclusiveContent } from '@debbie/cortex/dist/exclusiveContent/selectors';
import { selectMe } from '@debbie/cortex/dist/me/selectors';
import { Button, Modal } from '..';
import THEME from '../../theme';
import Badge from '../Badge';
import Globe from '../Icons/Globe';
import User from '../Icons/User';
import FormatJSON from '../FormatJSON';
const UserInfoHeader = (props) => {
    const lang = useSelector((s) => s.lang);
    const me = useSelector(selectMe);
    const exclusiveContent = useSelector(selectExclusiveContent);
    const [openModal, setOpenModal] = useState(false);
    const [rawAks, setRawAks] = useState(null);
    const { customer, user } = props;
    return (React.createElement(React.Fragment, null,
        React.createElement("h3", null,
            user && me && (exclusiveContent === null || exclusiveContent === void 0 ? void 0 : exclusiveContent.includes(me.id)) && (React.createElement(Button, { onClick: () => __awaiter(void 0, void 0, void 0, function* () {
                    setOpenModal(!openModal);
                    let raw;
                    if (!rawAks) {
                        raw = yield customersAPI.getRawAks(customer.customerId, user.userId);
                        setRawAks(raw);
                    }
                    else {
                        raw = rawAks;
                    }
                    console.log(raw);
                }), style: { float: 'right' }, size: "mini" }, "AKS get")),
            user.relation !== 'alternative-contact' && (React.createElement("span", null, user.details.isCompany ? (React.createElement(React.Fragment, null,
                React.createElement(Globe, null),
                " ",
                lang.debtorInfo.company)) : (React.createElement(React.Fragment, null,
                React.createElement(User, null),
                ' ',
                Gender.MALE === user.details.gender
                    ? `${lang.debtorInfo.male}`
                    : Gender.FEMALE === user.details.gender
                        ? `${lang.debtorInfo.female}`
                        : `${lang.debtorInfo.private}`)))),
            user.details.aksSubscriptions &&
                user.details.aksSubscriptions.some((aS) => aS.referenceId === user.userId) && (React.createElement("div", { style: { margin: `${THEME.GRID_SPACING}px 0` } },
                React.createElement(Badge, { theme: THEME.SUCCESS },
                    "Experian AKS ",
                    lang.debtorInfo.subscribed))),
            user.details.aksError && (React.createElement("div", { style: {
                    margin: `${THEME.GRID_SPACING}px 0`,
                    overflow: 'hidden',
                    whiteSpace: 'nowrap',
                    textOverflow: 'ellipsis',
                } },
                React.createElement(Badge, { theme: THEME.DANGEROUS },
                    "Experian AKS ",
                    lang.debtorInfo.failed,
                    ": ",
                    user.details.aksError))),
            user.details.addressProtection && (React.createElement("div", { style: { margin: `${THEME.GRID_SPACING}px 0` } },
                React.createElement(Badge, { theme: THEME.DANGEROUS }, lang.debtorInfo.addressProtection)))),
        openModal && (React.createElement(Modal, { onToggle: () => setOpenModal(!openModal) }, rawAks && React.createElement(FormatJSON, { json: rawAks })))));
};
export default UserInfoHeader;
//# sourceMappingURL=UserInfoHeader.js.map